import { Action } from 'redux';

import { ChangeExtractDsToLive } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IDataSourceDetailInfo, IDataSourceInfo } from '../../datasource/models/IDataSourceInfo';

export interface ChangeExtractDsToLiveAction extends Action {
  datasources: IDataSourceInfo[] | IDataSourceDetailInfo[];
}

export function changeExtractDsToLive(datasources: IDataSourceInfo[] | IDataSourceDetailInfo[]): ChangeExtractDsToLiveAction {
  return {
    type: ChangeExtractDsToLive,
    datasources: datasources
  };
}

export const isChangeExtractDsToLiveAction = isActionFactory<ChangeExtractDsToLiveAction>(ChangeExtractDsToLive);
